import anime from 'animejs/lib/anime.es.js'

const Dashoffset = 121.2422866821289

export default {
  watch: {
    tell() {
      this.attemptClearTellAnime()
    }
  },
  methods: {
    entryHotspotDesc(ele, done) {
      const target = ele.querySelector('.hotspot-desc')
      const leaderLine = ele.querySelector('.hotspot-leader-line')
      const eleAnime = anime.timeline({
        easing: "easeInOutSine",
        changeComplete: () => {},
        complete: (anim) => {
          done()
        }
      })

      if (leaderLine) {
        const polyline = leaderLine.querySelector('polyline')
        if (polyline) {
          eleAnime.add({
            targets: polyline,
            strokeDashoffset: [Dashoffset, 0],
            duration: this.transitionDuration * .05,
            direction: 'normal',
            easing: 'easeInSine'
          })
        }
      }

      if (target) {
        eleAnime.add({
          targets: target,
          opacity: [0.1, 1],
          scaleX: [0, 1],
          duration: this.transitionDuration * .1,
          easing: 'easeInSine'
        }, "-=40")
      }
    },
    leaveHotspotDesc(ele, done) {
      const target = ele.querySelector('.hotspot-desc')
      const leaderLine = ele.querySelector('.hotspot-leader-line')

      if (target) {
        const eleAnime = anime.timeline({
          easing: "easeOutInSine",
          changeComplete: () => {},
          complete: (anim) => {
            done()
          }
        })
        eleAnime.add({
          targets: target,
          opacity: [1, .1],
          scaleX: [1, 0],
          complete: () => {},
          duration: this.transitionDuration * .1,
          easing: 'easeInSine'
        })

        if (leaderLine) {
          eleAnime.add({
            targets: leaderLine.querySelector('polyline'),
            strokeDashoffset: [0, Dashoffset],
            duration: this.transitionDuration * .05,
            complete: () => {},
            direction: 'reverse',
            easing: 'easeInSine'
          }, "-=50")
        }
      }
    }
  }
}